import { createSelector } from '@ngrx/store';

export const getDocumentTypesState = createSelector(
    (state: any) => state.documentTypes,
    (state: any) => state.get('list')
);

export const getCreateDocumentTypeState = createSelector(
    (state: any) => state.documentTypes,
    (state: any) => state.get('createDocumentType')
);

export const getUpdateDocumentTypeState = createSelector(
    (state: any) => state.documentTypes,
    (state: any) => state.get('updateDocumentType')
);
 